var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaystoreLogo = function SvgPlaystoreLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "playstore_logo_svg__playstore_logo",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M9.388 9.52L.765 18c.144-.008.299-.038.444-.122l7.167-4.112 3.368-1.921L9.388 9.52zm3.06-3.022L9.944 8.969l2.504 2.46 3.059-1.738c.435-.249.496-.566.493-.734-.005-.278-.181-.538-.481-.697-.261-.139-2.195-1.258-3.071-1.762zM.124.392C.047.528 0 .688 0 .869v16.36c0 .131.028.249.075.355l8.746-8.615L.124.392zM.839 0l8.549 8.419 2.344-2.325L1.369.159C1.197.06 1.012.004.839 0z"
  })));
};
export default SvgPlaystoreLogo;